import oidc from 'oidc-client'

const identityServer = process.env.NODE_ENV === 'production' ? 'https://reg-api.idha.com/identity' : 'http://localhost:5656/identity'

const selfUrl = window.location.origin + process.env.BASE_URL

const options = {
  authority: identityServer,
  client_id: 'idha-workshop-product-register-spa',
  scope: 'openid profile idha-product-register-api idha-product-register-user',
  redirect_uri: selfUrl + '#/callback',
  response_type: 'code',
  // client_secret: 'secret',
  post_logout_redirect_uri: selfUrl,
  loadUserInfo: true,
  automaticSilentRenew: true,
  silent_redirect_uri: selfUrl + '#/silent'
}

const usrMgr = new oidc.UserManager(options)

function invalidateUser () {
  usrMgr
    .removeUser()
    .then(() => {
      window.sessionStorage.removeItem('accessToken')
      window.sessionStorage.removeItem('user_username')
      window.sessionStorage.removeItem('user_role')
    })
}

usrMgr.events.addUserSignedOut(() => {
  invalidateUser()
})

usrMgr.events.addUserLoaded((user) => {
  window.sessionStorage.setItem('accessToken', user.access_token)
  window.sessionStorage.setItem('user_username', user.profile.preferred_username)
  window.sessionStorage.setItem('user_role', user.profile.productRegisterUserType)
})

usrMgr.events.addAccessTokenExpired(() => {
  invalidateUser()
})

usrMgr.events.addAccessTokenExpiring(() => {
  console.log('Access token is expiring')
})

usrMgr.events.addSilentRenewError((err) => {
  console.error('Silent renew error', err)
})

export default {
  login () {
    usrMgr
      .signinRedirect()
      .then(() => {
        sessionStorage.setItem('postLoginRoute', window.location.hash)
      })
  },
  logout () { usrMgr.signoutRedirect() },
  loginCallback () {
    usrMgr
      .signinRedirectCallback()
      .then(() => {
        const postLoginRoute = sessionStorage.getItem('postLoginRoute')
        window.location = process.env.BASE_URL + (postLoginRoute || '')
      })
  },
  loginSilentCallback () {
    console.log('Handling silent login callback')
    usrMgr.signinSilentCallback()
  },
  checkIsLoggedIn: () => new Promise((resolve, reject) => {
    usrMgr.getUser().then((user) => {
      if (user) {
        resolve()
        return
      }

      reject(new Error('User is not logged in'))
    })
  }),
  getAccessToken () {
    return window.sessionStorage.getItem('accessToken')
  },
  getUsername () {
    return window.sessionStorage.getItem('user_username')
  },
  getUserRole () {
    return window.sessionStorage.getItem('user_role')
  }
}
